module.exports = __webpack_public_path__ + "static/media/tag.db8faa3f.svg";